import Dialog from '@mui/material/Dialog';
import React from 'react';
import {
  SurveyMultiSelectStep,
  SurveyOpenStep,
  SurveySingleSelectStep,
} from 'shared/components/ui/survey';
import { SurveyStep } from 'shared/hooks/use-survey-steps';

import { useDeleteAccountSurvey } from './use-delete-account-survey';

export type DeleteAccountSurveyDialogProps = {
  onDelete: () => void;
  onCancel: () => void;
};

export const DeleteAccountSurveyDialog: React.FC<
  DeleteAccountSurveyDialogProps
> = ({ onDelete, onCancel }) => {
  const survey = useDeleteAccountSurvey({ onDelete, onCancel });

  return (
    <Dialog open onClose={survey.onDismiss}>
      {survey.step === SurveyStep.Reason && (
        <SurveySingleSelectStep
          title={survey.reason.title}
          subtitle={survey.reason.subtitle}
          options={survey.reason.options}
          backLabel={survey.backLabel}
          onBack={survey.onBack}
          skipLabel={survey.skipLabel}
          onSkip={survey.onSkip}
        />
      )}

      {survey.step === SurveyStep.FollowUp &&
        survey.followUp &&
        (survey.followUp.isMulti ? (
          <SurveyMultiSelectStep
            title={survey.followUp.title}
            subtitle={survey.followUp.subtitle}
            options={survey.followUp.options}
            continueLabel={survey.continueLabel}
            onContinue={survey.followUp.onContinue}
            backLabel={survey.backLabel}
            onBack={survey.onBack}
          />
        ) : (
          <SurveySingleSelectStep
            title={survey.followUp.title}
            options={survey.followUp.options}
            backLabel={survey.backLabel}
            onBack={survey.onBack}
          />
        ))}

      {survey.step === SurveyStep.DetailOther && (
        <SurveyOpenStep
          title={survey.detailOther.title}
          placeholder={survey.detailOther.placeholder}
          value={survey.detailOther.value}
          onChangeText={survey.detailOther.onChange}
          onContinue={survey.detailOther.onContinue}
          continueLabel={survey.continueLabel}
          backLabel={survey.backLabel}
          onBack={survey.onBack}
        />
      )}

      {survey.step === SurveyStep.Open && (
        <SurveyOpenStep
          title={survey.open.title}
          placeholder={survey.open.placeholder}
          value={survey.open.value}
          onChangeText={survey.open.onChange}
          onContinue={survey.open.onContinue}
          continueLabel={survey.open.continueLabel}
          backLabel={survey.backLabel}
          onBack={survey.onBack}
        />
      )}
    </Dialog>
  );
};
